import constants from '@/services/constants';

export default {
  sortRanksDescendingCompareFunction: sortRanksDescendingCompareFunction,
  sortCardsDescendingByRankCompareFunction: function (cardOne, cardTwo) {
    let rankOne = cardOne[0];
    let rankTwo = cardTwo[0];
    return sortRanksDescendingCompareFunction(rankOne, rankTwo);
  },
  sortCardGroupsDescendingByRankCompareFunction: function (cardGroupOne, cardGroupTwo) {
    let rankOne = cardGroupOne[0][0];
    let rankTwo = cardGroupTwo[0][0];
    return sortRanksDescendingCompareFunction(rankOne, rankTwo);
  },
  getRankOneLower: function (rank) {
    return this.getRankNUnitsLower(rank, 1);
  },
  getRankNUnitsLower: function (rank, amountLower) {
    let rankIndex = constants.ranks.indexOf(rank);
    let lowerRankIndex = rankIndex + amountLower;

    if (lowerRankIndex === 13) {
      return 'a';
    }

    if (lowerRankIndex > 13) {
      throw new Error('Trying to get a rank that is too low.');
    }

    return constants.ranks[lowerRankIndex];
  },
  getRankNUnitsLowerShortDeck: function (rank, amountLower) {
    let rankIndex = constants.ranks.indexOf(rank);
    let lowerRankIndex = rankIndex + amountLower;

    if (lowerRankIndex === 9) {
      return 'a';
    }

    if (lowerRankIndex > 9) {
      throw new Error('Trying to get a rank that is too low.');
    }

    return constants.ranks[lowerRankIndex];
  },
  getHighestCardFromCards: function (cards) {
    cards.sort(this.sortCardsDescendingByRankCompareFunction);
    return cards[0];
  },
  getHighestRankFromCards: function (cards) {
    let ranks = this.getRanksFromCards(cards);
    return this.getHighestRankFromRanks(ranks);
  },
  getHighestRankFromRanks: function (ranks) {
    ranks.sort(sortRanksDescendingCompareFunction);
    return ranks[0];
  },
  getRanksFromCards: function (cards) {
    let ranks = [];

    cards.forEach(function (card) {
      let rank = card[0];

      if (ranks.indexOf(rank) === -1) {
        ranks.push(rank);
      }
    });

    ranks.sort(sortRanksDescendingCompareFunction);

    return ranks;
  },
  getRankIndexesFromCards: function (cards, aceOnBothEnds) {
    let ranks = this.getRanksFromCards(cards);
    return this.getRankIndexesFromRanks(ranks, aceOnBothEnds);
  },
  getRankIndexesFromCardsShortDeck: function (cards, aceOnBothEnds) {
    let ranks = this.getRanksFromCards(cards);
    return this.getRankIndexesFromRanksShortDeck(ranks, aceOnBothEnds);
  },
  getRankIndexesFromRanks: function (ranks, aceOnBothEnds) {
    let rankIndexes = [];

    ranks.forEach(function (rank) {
      rankIndexes.push(constants.ranks.indexOf(rank));
    });

    if (aceOnBothEnds && ranks.indexOf('a') > -1) {
      rankIndexes.push(13);
    }

    return rankIndexes;
  },
  getRankIndexesFromRanksShortDeck: function (ranks, aceOnBothEnds) {
    let rankIndexes = [];

    ranks.forEach(function (rank) {
      rankIndexes.push(constants.ranks.indexOf(rank));
    });

    if (aceOnBothEnds && ranks.indexOf('a') > -1) {
      rankIndexes.push(9);
    }

    return rankIndexes;
  },
  getRankPositionAmongstCommunityCards: function (rank, communityCardRanks) {
    let rankIndex = constants.ranks.indexOf(rank);
    let communityCardRankIndexes = [];

    if (communityCardRanks.length < 3) {
      throw new Error("Don't call getRankPositionAmongstCommunityCards with less than three community cards");
    }

    communityCardRanks.forEach(function (communityCardRank) {
      communityCardRankIndexes.push(constants.ranks.indexOf(communityCardRank));
    });
    communityCardRankIndexes.sort(function(a, b){ return a-b }); // sort descending

    if (communityCardRanks.length === 5) {
      if (rankIndex < communityCardRankIndexes[0]) {
        return 'over';
      } else if (rankIndex === communityCardRankIndexes[0]) {
        return 'top';
      } else if (rankIndex < communityCardRankIndexes[1]) {
        return 'over second';
      } else if (rankIndex === communityCardRankIndexes[1]) {
        return 'second';
      } else if (rankIndex < communityCardRankIndexes[2]) {
        return 'over third';
      } else if (rankIndex === communityCardRankIndexes[2]) {
        return 'third';
      } else if (rankIndex < communityCardRankIndexes[3]) {
        return 'over fourth';
      } else if (rankIndex === communityCardRankIndexes[3]) {
        return 'fourth';
      } else if (rankIndex < communityCardRankIndexes[4]) {
        return 'over bottom';
      } else if (rankIndex === communityCardRankIndexes[4]) {
        return 'bottom';
      } else if (rankIndex > communityCardRankIndexes[4]) {
        return 'under';
      } else {
        throw new Error('Problem trying to get the rank position amongst the community cards.');
      }
    }

    else if (communityCardRanks.length === 4) {
      if (rankIndex < communityCardRankIndexes[0]) {
        return 'over';
      } else if (rankIndex === communityCardRankIndexes[0]) {
        return 'top';
      } else if (rankIndex < communityCardRankIndexes[1]) {
        return 'over second';
      } else if (rankIndex === communityCardRankIndexes[1]) {
        return 'second';
      } else if (rankIndex < communityCardRankIndexes[2]) {
        return 'over third';
      } else if (rankIndex === communityCardRankIndexes[2]) {
        return 'third';
      } else if (rankIndex < communityCardRankIndexes[3]) {
        return 'over bottom';
      } else if (rankIndex === communityCardRankIndexes[3]) {
        return 'bottom';
      } else if (rankIndex > communityCardRankIndexes[3]) {
        return 'under';
      } else {
        throw new Error('Problem trying to get the rank position amongst the community cards.');
      }
    }

    else if (communityCardRanks.length === 3) {
      if (rankIndex < communityCardRankIndexes[0]) {
        return 'over';
      } else if (rankIndex === communityCardRankIndexes[0]) {
        return 'top';
      } else if (rankIndex < communityCardRankIndexes[1]) {
        return 'over middle';
      } else if (rankIndex === communityCardRankIndexes[1]) {
        return 'middle';
      } else if (rankIndex < communityCardRankIndexes[2]) {
        return 'over bottom';
      } else if (rankIndex === communityCardRankIndexes[2]) {
        return 'bottom';
      } else if (rankIndex > communityCardRankIndexes[2]) {
        return 'under';
      } else {
        throw new Error('Problem trying to get the rank position amongst the community cards.');
      }
    }
  },
  isFirstRankLargerThanSecond: function (rankOne, rankTwo) {
    let rankOneIndex = constants.ranks.indexOf(rankOne);
    let rankTwoIndex = constants.ranks.indexOf(rankTwo);

    return rankOneIndex < rankTwoIndex;
  },
  getSpaceBetweenRanks: function (ranks) {
    let spaceBetweenRanks = 0;
    let rankIndexes = ranks.map(function (rank) {
      return constants.ranks.indexOf(rank);
    });

    rankIndexes.sort(function (a, b) {
      return b - a;
    });

    for (let i = 0; i < rankIndexes.length - 1; i++) {
      spaceBetweenRanks += rankIndexes[i] - rankIndexes[i + 1];
    }

    return spaceBetweenRanks;
  },
  forEachRank: function (firstRank, lastRank, cb) {
    let highRankIndex = constants.ranks.indexOf(firstRank); // 2
    let lowRankIndex = constants.ranks.indexOf(lastRank); // 5

    for (let i = highRankIndex; i <= lowRankIndex; i++) {
      cb(constants.ranks[i]);
    }
  },
};

function sortRanksDescendingCompareFunction(rankOne, rankTwo) {
  let rankOneIndex = constants.ranks.indexOf(rankOne);
  let rankTwoIndex = constants.ranks.indexOf(rankTwo);

  // invalid ranks
  if (rankOneIndex === -1 || rankTwoIndex === -1) {
    throw new Error('Invalid rank(s).');
  }

  // rankOne is bigger
  if (rankOneIndex < rankTwoIndex) {
    return -1
  }

  // rankTwo is bigger
  else if (rankTwoIndex < rankOneIndex) {
    return 1;
  }

  // they're equal
  else {
    return 0;
  }
}



// WEBPACK FOOTER //
// ./src/services/utilities/ranks.js